import { DetectorModes } from "types/createDetector";
import { Detector } from "types/detectors";


export function getTotalClasses(detector: Detector): number {
  const config = detector.mode_configuration;

  switch (detector.mode) {
    case DetectorModes.MULTICHOICE:
      return config?.class_names?.length ?? 0;
    case DetectorModes.COUNT:
      return config?.max_count ? config.max_count + 2 : 2;
    default:
      return 2;
  }
}
